const LOCAL_HOST_PATTERN = /^(localhost|127\.0\.0\.1)$/i;

export const COMMUNITY_CATEGORIES = [
  { id: '', label: 'All' },
  { id: 'strategy', label: 'Strategies' },
  { id: 'backtest', label: 'Backtests' },
  { id: 'showcase', label: 'Showcases' },
  { id: 'question', label: 'Questions' },
  { id: 'resource', label: 'Resources' },
];

const API_BASE_URL = (() => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '');
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && LOCAL_HOST_PATTERN.test(window.location.hostname)) {
    return 'http://localhost:5000';
  }
  return '';
})();

function buildUrl(path, query = {}) {
  const url = new URL(`${API_BASE_URL}${path}`, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
}

async function requestCommunity(path, options = {}) {
  const { method = 'GET', body, token, query = {}, formData } = options;
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (body) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(buildUrl(path, query), {
    method,
    headers: Object.keys(headers).length ? headers : undefined,
    body: formData || (body ? JSON.stringify(body) : undefined),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || 'Community request failed.');
  }
  return payload;
}

export function buildCommunityAssetUrl(filePath = '') {
  if (!filePath) {
    return '';
  }
  if (/^https?:\/\//i.test(filePath)) {
    return filePath;
  }
  const trimmed = filePath.replace(/^\/+/, '');
  return API_BASE_URL ? `${API_BASE_URL}/${trimmed}` : `/${trimmed}`;
}

export async function listCommunityThreads({ category = '', search = '', token }) {
  return requestCommunity('/api/community/threads', {
    query: { category, search },
    token,
  });
}

export async function fetchCommunityThread(threadId, token) {
  return requestCommunity(`/api/community/threads/${threadId}`, { token });
}

export async function createCommunityThread(payload, token) {
  return requestCommunity('/api/community/threads', {
    method: 'POST',
    body: payload,
    token,
  });
}

export async function addCommunityComment(threadId, body, token) {
  return requestCommunity(`/api/community/threads/${threadId}/comments`, {
    method: 'POST',
    body: { body },
    token,
  });
}

export async function addCommunityLinkAttachment(threadId, payload, token) {
  return requestCommunity(`/api/community/threads/${threadId}/attachments/links`, {
    method: 'POST',
    body: payload,
    token,
  });
}

export async function uploadCommunityAttachments(threadId, files, token) {
  const formData = new FormData();
  Array.from(files || []).forEach((file) => {
    formData.append('files', file);
  });
  return requestCommunity(`/api/community/threads/${threadId}/attachments`, {
    method: 'POST',
    formData,
    token,
  });
}

export async function fetchCommunityStrategy(threadId, token) {
  return requestCommunity(`/api/community/threads/${threadId}/strategy`, { token });
}

export async function importCommunityStrategy(threadId, token) {
  return requestCommunity(`/api/community/threads/${threadId}/import-strategy`, {
    method: 'POST',
    token,
  });
}
